import * as crowdImport from '../services/crowdImport';

export default {
  namespace: 'crowdImport',

  state: {
    TagAndRuleDetail: null,
    ruleLabelDirectoryList: null,
    tagBehaviorList: null,
    tagBehaviorConditionList: null,
  },

  effects: {
    // 创建非集合标签规则
    *insertOrUpdateGroupAndRule({ payload: { values }, callback }, { call }) {
      const response = yield call(
        crowdImport.insertOrUpdateGroupAndRule,
        values,
      );
      // response.code === 0 && callback && callback();
      if (callback && typeof callback === 'function') {
        return callback(response?.code);
      }
    },
    // 非集合标签规则详情
    *queryTagAndRule({ payload: { values }, callback }, { call, put }) {
      const response = yield call(crowdImport.queryTagAndRule, values);
      yield put({
        type: 'save',
        payload: {
          TagAndRuleDetail: response?.data,
        },
      });
      response.code === 0 && callback && callback(response.data);
    },
    // 字段列表
    *queryFileList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(crowdImport.queryFileList, values);
      const responseTag = yield call(crowdImport.getQueryTagOperatorValue, []);
      const treeList = response.data;
      yield put({
        type: 'save',
        payload: {
          ruleLabelDirectoryList: treeList,
          queryTagOperatorValue: responseTag.data,
        },
      });
      response.code === 0 && callback && callback(response.data);
    },
    // 行为列表
    *queryTagBehaviorList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(crowdImport.queryTagBehaviorList, values);
      const list = response?.data.map((item) => {
        return {
          nameZh: item.behaviorName,
          dictValue: item.id,
          ...item,
        };
      });
      yield put({
        type: 'save',
        payload: {
          tagBehaviorList: list,
        },
      });
      // response.code === 0 && callback && callback(response.data);
      response.code === 0 && callback && callback(list);
    },
    // 取值方式
    *queryTagBehaviorConditionList(
      { payload: { values }, callback },
      { call, put },
    ) {
      const response = yield call(
        crowdImport.queryTagBehaviorConditionList,
        values,
      );
      yield put({
        type: 'save',
        payload: {
          tagBehaviorConditionList: response?.data || [],
        },
      });
      response.code === 0 && callback && callback(response.data);
    },
    // 人群导入字段配置
    *queryGroupImportConfigList(
      { payload: { values }, callback },
      { call, put },
    ) {
      const response = yield call(
        crowdImport.queryGroupImportConfigList,
        values,
      );
      const arr = (response?.data || []).map((item) => ({
        label: item.exportFileName,
        value: String(item.id),
        fileTemplateUrl: item.fileTemplateUrl,
      }));
      yield put({
        type: 'save',
        payload: {
          typeList: arr,
        },
      });
      response.code === 0 && callback && callback(response.data);
    },
  },
  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },
  subscriptions: {},
};
